import styles from './index.module.scss';

type Props = {
  readonly className?: string;
};

const LogtoSignature = ({ className }: Props) => {
  return (
    <div className={className}>
      <a
        className={styles.signature}
        aria-label="Powered By Sagebridge"
        href="https://sagebridge.in"
        target="_blank"
        rel="noopener"
      >
        <span className={styles.text}>Powered by Sagebridge</span>
      </a>
    </div>
  );
};

export default LogtoSignature;
